import { CultureInfo } from '../culture-info.model';
import { CultureInfoEn } from './en';

/**
 * @ignore
 */
export const CultureInfoEnGB: CultureInfo = {
  name: 'en-GB',
  displayName: 'English (United Kingdom)',
  iso3LanguageCode: 'eng',
  iso2LanguageCode: 'en',
  ietfLanguageTag: 'en-GB',
  parent: CultureInfoEn
};
